export const PRODUCTS_ACTION_TYPES = {
    // SET_PRODUCTS: 'product/SET_PRODUCTS',
    FETCH_PRODUCTS_START: 'product/FETCH_PRODUCTS_START',
    FETCH_PRODUCTS_SUCCESS: 'product/FETCH_PRODUCTS_SUCCESS',
    FETCH_PRODUCTS_FAILED: 'product/FETCH_PRODUCTS_FAILED',
};